module.exports = __webpack_public_path__ + "assets/bd5ed479d5a47f1e8e9da9edf7cd3aae.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/mystery/SSound2.mp3
 ** module id = 353
 ** module chunks = 0
 **/